import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { RequireAuth } from '@/components/RequireAuth';
import { Dashboard } from '@/pages/Dashboard';
import { MonitorForm } from '@/pages/MonitorForm';
import { Incidents } from '@/pages/Incidents';
import { Settings } from '@/pages/Settings';
import { PublicStatus } from '@/pages/PublicStatus';
import { Login } from '@/pages/Login';

// MonitorDetail pulls in recharts (~400 KB). Lazy-load it so the public status
// page and the admin dashboard don't pay that cost.
const MonitorDetail = lazy(() =>
  import('@/pages/MonitorDetail').then((m) => ({ default: m.MonitorDetail }))
);

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public status page at the root */}
        <Route path="/" element={<PublicStatus />} />
        <Route path="/login" element={<Login />} />

        {/* Admin app behind /admin — RequireAuth redirects to /login on 401. */}
        <Route
          path="/admin"
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="monitors/new" element={<MonitorForm />} />
          <Route
            path="monitors/:id"
            element={
              <Suspense fallback={null}>
                <MonitorDetail />
              </Suspense>
            }
          />
          <Route path="monitors/:id/edit" element={<MonitorForm />} />
          <Route path="incidents" element={<Incidents />} />
          <Route path="settings" element={<Settings />} />
        </Route>

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}
